import { Box, Button, Card, CardActions, CardContent, Checkbox, Divider, FormControlLabel, Icon, Modal, Tooltip, Typography } from "@material-ui/core";
import React, { ReactNode, useCallback, useEffect, useState } from "react";
import { FC } from "react";
import { useHistory } from "react-router-dom";
import { CollectionUtil, Formater, TypeRecords, ValidateUtil } from "src/framework/commons";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import { StringUtil } from "src/framework/commons/StringUtil";
import { FullWidthButton } from "src/framework/components/buttons";
import { FlatButton } from "src/framework/components/buttons/FlatButton";
import { BottomBar } from "src/framework/components/commons";
import { InputText, InputComboBoxList } from "src/framework/components/forms";
import { IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { notifierStore } from "src/framework/store/";
import { PagamentosProvider } from "src/providers";
import { ClientesProvider } from "src/providers/clientes/ClientesProvider";
import { EnderecosClienteProvider } from "src/providers/clientes/EnderecosClientesProvider";
import { getPaises } from "src/store/global.store";
import { PedidoStore } from "src/store/vendas/PedidoStore";
import theme from "src/theme/light";
import { Clientes, EnderecosClientes, ErrorValidate, Paises, PedidoType, TTIPO_ORIGEM_ENDERECO } from "src/types";
import { EnderecoFormProperties, FromEndereco } from "../EnderecoForm";
import { isValidCPF } from '@brazilian-utils/brazilian-utils';
import { isValidCNPJ } from '@brazilian-utils/brazilian-utils';

import "./style.scss";
import { parsePhone } from "src/framework/commons/masks";
import { UserType } from "src/framework/store/LoginStore/login.types";
import { Alert } from "@material-ui/lab";
import { MAXLENGTH_NOMES } from "src/constants";
import { PedidosProvider } from "src/providers/pagamentos/PedidoProvider";

interface ErrorState {
    documento: ErrorValidate
    nome: ErrorValidate
    nome_fantasia: ErrorValidate
    email: ErrorValidate
    telefone: ErrorValidate
    inscricao_estadual: ErrorValidate
    tipo_contribuinte: ErrorValidate
}
enum TIPOS_CONTRIBUINTE {
    ISENTO = "isento",
    CONTRIBUINTE = "contribuinte",
    NAO_CONTRIBUINTE = "nao_contribuinte",
}
const DISABLED_TIPOS_CONTRIBUINTE = [TIPOS_CONTRIBUINTE.ISENTO, TIPOS_CONTRIBUINTE.NAO_CONTRIBUINTE];


const INITIAL_ERROR_STATE: ErrorState = {
    documento: {
        hasError: false,
        hintText: ""
    },
    nome: {
        hasError: false,
        hintText: ""
    },
    nome_fantasia: {
        hasError: false,
        hintText: ""
    },
    telefone: {
        hasError: false,
        hintText: ""
    },
    inscricao_estadual: {
        hasError: false,
        hintText: ""
    },
    email: {
        hasError: false,
        hintText: ""
    },
    tipo_contribuinte: {
        hasError: false,
        hintText: ""
    },
}

const tiposContribuinte = [
    {
        text: "Isento",
        value: "isento"
    },
    {
        text: "Contribuinte",
        value: "contribuinte"
    },
    {
        text: "Não Contribuinte",
        value: "nao_contribuinte"
    }
]

const styles = {
    modalBox: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        bgcolor: "background.paper",
        boxShadow: 24,
        padding: "30px",
        borderRadius: 4,
    },
};

const cepParser = (cep: string) => {
    let value = cep;
    value = value.replace(/\D/g, "");
    value = value.replace(/^(\d{5})(\d)/, "$1-$2");
    cep = value;
    return cep;
}

const enderecosProvider = new EnderecosClienteProvider();
const clientesProvider = new ClientesProvider();
const pagamentosProvider = new PagamentosProvider();
const pedidosProvider = new PedidosProvider();

const ClienteForm: FC = () => {
    const [paisesListState, setPaisesListState] = useState<any[]>();
    const [triangular, setTriangular] = useState(false);
    const [tipoCliente, setTipoCliente] = React.useState<string>(triangular ? "juridica" : "fisica");
    const [openModal, setOpenModal] = React.useState(false);
    const [openModalEdit, setOpenModalEdit] = React.useState(false);
    const [paisState, setPaisState] = React.useState<Paises>();
    const [enderecoEdit, setEnderecoEdit] = React.useState<EnderecosClientes>();
    const [enderecos, setEnderecos] = React.useState<any[]>([]);
    const [cliente, setCliente] = React.useState<Clientes | null>(null);
    const [enderecoSelecionado, setEnderecoSelecionado] = React.useState<number>(0);

    const [idClienteBase, setIdClienteBase] = React.useState<number>(0);
    const [isWhatsApp, setIsWhatsApp] = React.useState(false);
    const [tipoContribuinteState, setTipoContribuinteState] = useState<{ text: string, value: string } | null>(null);
    const [disabledContribuinte, setDisabledContribuinte] = React.useState(false);
    const [searchClient, setSearchClient] = React.useState(true);
    const [indexEdicaoCliente, setIndexEdicaoCliente] = useState<number>(-1);
    const [disabledList, setDisabledList] = useState<TIPOS_CONTRIBUINTE[]>([]);
    const [searchedClientCRM, setSearchedClientCRM] = React.useState(false);
    const [limparEndereco, setLimparEndereco] =  React.useState(false);

    const [errorState, setErrorState] = React.useState<ErrorState>(INITIAL_ERROR_STATE);

    const history = useHistory();

    const userInfo = LocalStorage.get<UserType>("solar.userInfo", true)

    const init = async () => {
        const paises = await getPaises();
        if (paises) {
            setPaisesListState(paises);
            setPaisState(paises.find((pais: Paises) => pais.nome === 'BRASIL'));
        }
    }

    useEffect(() => {
        (async () => {
            await consultarCliente();
        })();
        init();
    }, []);

    useEffect(() => {

        init();

    }, [paisesListState]);

    useEffect(() => {
        if (idClienteBase > 0 && cliente?.documento && !searchedClientCRM) {
            consultaClienteCRM(cliente?.documento);
            setSearchedClientCRM(true);
        };
    }, [idClienteBase, cliente?.documento, searchedClientCRM]);

    const limparClienteState = (documento: string): Clientes => {
        const _clienteState: Clientes = {
            contato_whatsapp: "",
            documento: "",
            email: "",
            enderecos: [],
            inscricao_estadual: "",
            fantasia: "",
            nome: "",
            telefone: "",
            tipo_contribuinte: null,
            tipo_pessoa: "fisica",
            usa_whatsapp: false,
            usuario_id: null,
        }
        _clienteState.documento = documento
        setEnderecos([]);
        setIdClienteBase(0);
        setIsWhatsApp(false);
        setTipoContribuinteState(null);
        setEnderecoSelecionado(0);

        return _clienteState;
    }

    const atualizarClienteState = (data: any) => {

        if (data?.documento) {
            data.documento = Formater.toString(data.documento, TypeRecords.CPF_CNPJ)
        }
        if (data?.telefone) {
            data.telefone = parsePhone(data.telefone)
        }

        if (data?.contato_whatsapp) {
            data.contato_whatsapp = parsePhone(data.contato_whatsapp)
        }

        setCliente(data);
        setEnderecos(data.enderecos);
        setIdClienteBase(data?.id);
        setIsWhatsApp(data?.usa_whatsapp);
        const tipo_contribuinte = tiposContribuinte.find((t: any) => t.value === data.tipo_contribuinte) || null;

        setTipoContribuinteState(tipo_contribuinte ? { ...tipo_contribuinte } : null);

        console.log(">>>", tipo_contribuinte);
        if (tipo_contribuinte?.value === 'isento') {
            setDisabledContribuinte(true);
        } else {
            setDisabledContribuinte(false);
        }

        if (data.tipo_pessoa) {
            if(data.tipo_pessoa === "fisica" && triangular){
                setTipoCliente("juridica")
            }else{
                setTipoCliente(data.tipo_pessoa);
            }
        }

        if (data.enderecos) {
            const idEndereco: EnderecosClientes = data?.enderecos?.find((e: EnderecosClientes) => e.tipo === "principal");
            if (idEndereco?.id) {
                setEnderecoSelecionado(idEndereco.id);
            }
        }
    }

    const consultarCliente = async (): Promise<void> => {
        const _pedido = PedidoStore.getPedido();
        const documento = (_pedido?.documento || cliente?.documento || "").replace(/\D/g, "");
        console.log("_pedido>>>", _pedido)
        if(_pedido?.destino === "triangular"){
            setTriangular(true);
        }

        if (userInfo?.tipoCliente !== "representante") {
            const response = await clientesProvider.getClienteListar()
            if (response.statusCode === STATUS_CODE.OK && response?.data?.length) {
                const _data = [...response.data].shift();
                setSearchClient(false);
                atualizarClienteState(_data);
            }
        }

        if (userInfo?.tipoCliente === "representante" && documento) {
            const response = await clientesProvider.getClienteByDocumento(String(documento))
            if (response.statusCode === STATUS_CODE.OK && response?.data?.length) {
                const _data = [...response.data].shift();
                setSearchClient(false);
                atualizarClienteState(_data);
            }
        }

    }

    const renderPessoaFisica = (): ReactNode => {
        return (
            <>
                <div className="X12 M6">
                    <InputText label="Nome completo do cliente *" fullWidth
                        value={cliente?.nome ? StringUtil.truncate(cliente.nome, MAXLENGTH_NOMES) : ""}
                        error={errorState.nome.hasError}
                        helperText={errorState.nome.hintText}
                        disabled={searchClient || !!cliente?.cliente_sales_force}
                        maxLength={MAXLENGTH_NOMES}
                        onChange={(e: any) => {
                            const state = { ...cliente };
                            state.nome = e.target.value;

                            setCliente(state);
                        }}
                        onBlur={(e: any) => {
                            const _errorState = { ...errorState };
                            const hasTwoNames = e?.target?.value?.trim()?.split(" ")?.length >= 2;
                            _errorState.nome.hasError = !hasTwoNames
                            _errorState.nome.hintText = hasTwoNames ? "" : "O Nome do cliente deve conter pelo menos 2 nomes";
                            setErrorState(_errorState)
                        }}
                        onFocus={(e: any) => {
                            const _errorState = { ...errorState };
                            _errorState.nome.hasError = false;
                            setErrorState(_errorState)
                        }}
                    />
                </div>
            </>
        )
    }
    const maskEspeciais = useCallback((str: string)=>{
        return str.replace(/[^0-9]/g, '');
    },[cliente?.inscricao_estadual])

    const renderPessoaJuridica = (): ReactNode => {
        return (
            <>

                <div className="X12 M2">
                    <InputComboBoxList
                        id={`form-tipo-contribuinte`}
                        key={`form-tipo-contribuinte`}
                        disabled={searchClient || !!cliente?.cliente_sales_force}
                        options={tiposContribuinte}
                        label={'Tipo Contribuinte *'}
                        value={tipoContribuinteState}
                        disableClearable
                        textField="text"
                        valueField="value"
                        error={errorState.tipo_contribuinte.hasError}
                        renderOptions={(option: any) => {
                            if(triangular && option.value === TIPOS_CONTRIBUINTE.CONTRIBUINTE){
                                return(
                                    <Tooltip title="Única opção disponível para projetos com triangulação">
                                        <span>{option.text}</span>
                                    </Tooltip>
                                )
                            }
                            return `${option.text}`;
                        }}
                        renderOptionsLabel={(option: any) => {
                            return `${option.text}`
                        }}
                        onChange={(e: any) => {
                            if (e) {
                                const state = { ...cliente };
                                state.tipo_contribuinte = e.value;
                                if (e.value === 'isento') {
                                    state.inscricao_estadual = "";
                                    setDisabledContribuinte(true);
                                } else {
                                    setDisabledContribuinte(false);
                                }
                                setCliente(state);
                                setTipoContribuinteState(e);

                            }
                        }}
                        optionsDisabled={disabledList}
                    />
                </div>
                <div className="X12 M4">
                    <InputText
                        id={`input-inscricao-estadual`}
                        key={`input-inscricao-estadual`}
                        label="Inscrição Estadual *"
                        fullWidth
                        value={maskEspeciais(String(cliente?.inscricao_estadual))}
                        disabled={disabledContribuinte || searchClient || !!cliente?.cliente_sales_force}
                        error={errorState.inscricao_estadual.hasError}
                        onChange={(e: any) => {
                            const state = { ...cliente };
                            state.inscricao_estadual = maskEspeciais(e.target.value);
                            setCliente(state);
                        }}
                    />
                </div>

                <div className="X12 M6">
                    <InputText
                        id={`input-razao-social`}
                        key={`input-razao-social`}
                        label="Razão Social *" fullWidth
                        value={cliente?.nome ? StringUtil.truncate(cliente.nome, MAXLENGTH_NOMES) : ""}
                        maxLength={MAXLENGTH_NOMES}
                        disabled={searchClient || !!cliente?.cliente_sales_force}
                        error={errorState.nome.hasError}
                        onChange={(e: any) => {
                            const state = { ...cliente };
                            state.nome = e.target.value;
                            setCliente(state);
                        }}
                    />
                </div>

                <div className="X12 M6">
                    <InputText
                        label="Nome Fantasia *"
                        fullWidth
                        error={errorState.nome_fantasia.hasError}
                        value={cliente?.fantasia ? StringUtil.truncate(cliente.fantasia, MAXLENGTH_NOMES).normalize('NFD').replace(/([\u0300-\u036f]|[^0-9a-zA-Z- ])/g, '') : ""}
                        maxLength={MAXLENGTH_NOMES}
                        disabled={searchClient || !!cliente?.cliente_sales_force}
                        onChange={(e: any) => {
                            const state = { ...cliente };
                            state.fantasia = e.target.value;
                            setCliente(state);
                        }}
                    />
                </div>
            </>
        )
    }

    const renderEnderecoAdicionar = (): ReactNode => {

        const enderecoProperties: EnderecoFormProperties = {
            edit: false,
            paises: paisesListState,
            paisDefault: paisState,
            onSave: onSaveEndereco,
            onCancel: handleCloseModal,
            tipoEndereco: "entrega",
        }

        return <>
            <Modal
                id="modal-endereco-adicionar"
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className="box-modal-endereco" sx={styles.modalBox}>
                    <Typography id="modal-modal-description">
                        <strong style={{ color: theme.palette.grey[500] }}>Endereço de entrega do produto</strong>
                        <FromEndereco {...enderecoProperties} />
                    </Typography>
                </Box>
            </Modal>
        </>
    }

    const renderEnderecoEditar = (): ReactNode => {

        const enderecoProperties: EnderecoFormProperties = {
            edit: true,
            paises: paisesListState,
            paisDefault: paisState,
            onSave: onSaveEndereco,
            onCancel: handleCloseModalEdit,
            endereco: enderecoEdit,
            tipoEndereco: enderecoEdit?.tipo ? enderecoEdit?.tipo : "principal"
        }

        return <>
            <Modal
                id="modal-endereco-editar"
                open={openModalEdit}
                onClose={handleCloseModalEdit}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className="box-modal-endereco" sx={styles.modalBox}>
                    <Typography id="modal-modal-description">
                        <FromEndereco {...enderecoProperties} />
                    </Typography>
                </Box>
            </Modal>
        </>
    }

    const renderEnderecoAdicionarClienteNovo = (): ReactNode => {

        const enderecoProperties: EnderecoFormProperties = {
            edit: false,
            paises: paisesListState,
            paisDefault: paisState,
            onSave: onSaveEndereco,
            tipoEndereco: "principal",
            clean: limparEndereco,
        }

        return <>
            <div className="X12" style={{ marginRight: "auto", marginLeft: "auto", padding: "10px" }}>
                <div style={{display: "flex", alignSelf: "flex-start", paddingBottom: "5px"}}>
                    {tipoCliente === "juridica" && (
                        <span>
                            <strong>O endereço cadastrado será validado conforme o Sintegra. Por favor, verifique os dados antes de prosseguir.</strong>
                        </span>
                    )}
                </div>
                <div style={{ padding: "10px", borderRadius: "10px", border: "1px solid rgba(51, 51, 51, 0.125)" }}>
                    <FromEndereco {...enderecoProperties} />
                </div>
            </div>
        </>
    }

    const handleOpenModal = () => setOpenModal(true);
    const handleCloseModal = () => setOpenModal(false);

    const handleOpenModalEdit = () => setOpenModalEdit(true);
    const handleCloseModalEdit = () => setOpenModalEdit(false);

    // const updateEnderecoState = (endereco: any): void => {
    //     const enderecoState = [...enderecos];

    //     const idxEndereco = enderecoState.findIndex((_end) => _end.id === endereco.id);

    //     if (idxEndereco > -1) {
    //         enderecoState[idxEndereco] = endereco;
    //     }

    //     if (idxEndereco === -1) {
    //         enderecoState.push(endereco);
    //     }

    //     setEnderecos(enderecoState)
    //     return;
    // }

    const onSaveEndereco = async (endereco: any) => {

        if (cliente?.tipo_contribuinte !== "contribuinte" && cliente?.tipo_pessoa === "juridica") {
            if (validaClienteTemEnderecos()) {

                const enderecoPrincipal = enderecos?.find((e: EnderecosClientes) => e.tipo === "principal");

                if (enderecoPrincipal.cidade.estado_id !== endereco.cidade.estado_id) {
                    notifierStore.setNotifier({
                        title: "Aviso",
                        content: "Endereço informado é de um estado diferente do endereço principal!",
                        timeOut: 3500,
                        onClose: () => {
                            notifierStore.setOpen(false)
                        }
                    })
                    notifierStore.setOpen(true)

                    return
                }
            }
        }

        const enderecoEnv = {
            ...endereco,
            sequencial: endereco.sequencial ? endereco.sequencial : enderecos ? enderecos?.length + 1 : 1,
            cliente_id: cliente?.id
        }

        if (cliente?.id && cliente?.id > 0) {
            let response: IDataResponse | null = null;
            if (endereco.id > 0) {
                response = await enderecosProvider.putEnderecos(enderecoEnv);
                if (response.statusCode === STATUS_CODE.OK) {
                    const _data = [...response.data].shift();
                    // updateEnderecoState(_data)
                }
            } else {
                response = await enderecosProvider.postEnderecos(enderecoEnv);
                if (response.statusCode === STATUS_CODE.CREATED) {
                    const _data = [...response.data].shift();
                    // updateEnderecoState(_data)
                }
            }

            console.log("response antes ConsultarCliente>>>", response)
            if ([STATUS_CODE.OK, STATUS_CODE.CREATED].includes(response.statusCode)) {
                await consultarCliente();
            }
        }
        else {
            const state: Clientes = { ...cliente };
            if (cliente) {

                let enderecosState: any[] = [];

                if (enderecos) {
                    enderecosState = [...enderecos];
                }

                if(indexEdicaoCliente === -1){
                    enderecosState.push(enderecoEnv);
                }else{
                    enderecosState[indexEdicaoCliente] = enderecoEnv;
                }

                setIndexEdicaoCliente(-1);

                state.enderecos = enderecosState;
                setEnderecos(enderecosState);
                setCliente(state);
                // setEnderecos([...endereco, enderecoEnv])
            }
        }
        handleCloseModal();
        handleCloseModalEdit();
    };

    const onSaveCliente = async (clienteInput: any) => {
        (clienteInput as Clientes).documento = (clienteInput as Clientes).documento?.replaceAll(/\D/g, "");
        (clienteInput as Clientes).telefone = (clienteInput as Clientes).telefone?.replaceAll(/\D/g, "");
        (clienteInput as Clientes).contato_whatsapp = (clienteInput as Clientes).contato_whatsapp?.replaceAll(/\D/g, "");
        (clienteInput as Clientes).nome = (clienteInput as Clientes).nome?.trim();
        let response: IDataResponse;

        if (userInfo?.tipoCliente === "representante") {
            delete clienteInput.usuario_id;
        }

        if (clienteInput.tipo_pessoa === 'fisica') {
            clienteInput.tipo_contribuinte = 'nao_contribuinte'
        }

        if (validaClienteExiste()) {
            if(!!cliente?.cliente_sales_force) {
                const notUpdateFields = [
                    'documento',
                    'email',
                    'telefone',
                    'tipo_contribuinte',
                    'inscricao_estadual',
                    'fantasia',
                    'nome',
                ]

                notUpdateFields.forEach(field => {
                    delete clienteInput[field]
                })
            }

            response = await clientesProvider.putCliente(clienteInput);
            if (response.statusCode === STATUS_CODE.OK) {
                setCliente(response.data[0]);
            }

        } else {
            response = await clientesProvider.postCliente(clienteInput);
            if (response.statusCode === STATUS_CODE.CREATED) {
                setCliente(response.data[0]);
                setIdClienteBase(response.data[0].id);
            }
        }

        return response;
    };

    const validaClienteExiste = () => {
        return idClienteBase > 0 ? true : false
    }

    const validaClienteExisteDocumento = () => {
        return idClienteBase > 0 && userInfo?.tipoCliente !== "representante" ? true : false
    }

    const validaClienteTemEnderecos = () => {
        if (enderecos) {
            return enderecos.length > 0;
        }

        return false;
    }

    const validaDocumento = (documento: string) => {
        const documentoEnv = documento.replace(/\D/g, "");

        let consultarDocumento = false;
        const tipoDocumento = StringUtil.validaTipoDocumento(documentoEnv);

        if (tipoCliente !== "juridica" && tipoDocumento === "CPF") {
            consultarDocumento = true;
        } else if (tipoDocumento === "CNPJ") {
            consultarDocumento = true;
        }

        if (documentoEnv && consultarDocumento) {
            const errors = { ...errorState }
            if (tipoCliente === "fisica" && !isValidCPF(documento)) {
                errors.documento.hasError = true;
                setErrorState({ ...errors })
                notifierStore.setNotifier({
                    title: "Aviso",
                    content: "CPF Invalido",
                    timeOut: 3500,
                    onClose: () => {
                        notifierStore.setOpen(false)
                    }
                })
                notifierStore.setOpen(true)
                return;
            } else if (tipoCliente === "juridica" && !isValidCNPJ(documento)) {
                errors.documento.hasError = true;
                setErrorState({ ...errors })
                notifierStore.setNotifier({
                    title: "Aviso",
                    content: "CNPJ Invalido",
                    timeOut: 3500,
                    onClose: () => {
                        notifierStore.setOpen(false)
                    }
                })
                notifierStore.setOpen(true)
                return;
            }
        }

        return true
    }

    const consultaClienteCRM = async (documento: string): Promise<void> => {
        const documentoEnv = documento.replace(/\D/g, "");
        if (documentoEnv) {
            const errors = { ...errorState }

            errors.documento.hasError = false;
            setErrorState({ ...errors })
            limparClienteState(documentoEnv);
            setCliente(limparClienteState(documento));
            const response = await clientesProvider.getClienteCRMByDocumento(documentoEnv);

            if (![STATUS_CODE.OK, STATUS_CODE.NO_CONTENT].includes(response.statusCode)) {
                notifierStore.setNotifier({
                    title: "Aviso",
                    content: response.message,
                    timeOut: 3500,
                    onClose: () => {
                        notifierStore.setOpen(false)
                    }
                })
                notifierStore.setOpen(true)
                return;
            }

            if (response.data.length > 0) {
                const _cliente = [...response.data].shift();
                atualizarClienteState(_cliente);
                setSearchClient(false)
                setSearchedClientCRM(true);
                return;
            }

            notifierStore.setNotifier({
                title: "Aviso",
                content: "Nenhum cadastro encontrado. Preencha os campos para criar um novo registro.",
                timeOut: 3500,
                onClose: () => {
                    notifierStore.setOpen(false)
                }
            })
            notifierStore.setOpen(true)

            setSearchClient(false)
            return;
        }
    }

    const isValidEmail = (email?: string | null) => {
        if (!email) return true;
        return ValidateUtil.isValidEmail(email) && ValidateUtil.isValidEmailFromLib(email);
    }

    const validateCliente = (): boolean => {
        const errorMessages: string[] = []
        const errors = { ...errorState }

        if (!cliente?.documento || cliente?.documento === "") {
            errorMessages.push(`O campo "Documento" é obrigatório.`)
            errors.documento = { hasError: true, hintText: "" }
        } else {
            if (tipoCliente === "fisica" && !isValidCPF(cliente?.documento)) {
                errorMessages.push(`Documento informado é inválido.`)
                errors.documento = { hasError: true, hintText: "" }
            } else if (tipoCliente === "juridica" && !isValidCNPJ(cliente?.documento)) {
                errorMessages.push(`Documento informado é inválido.`)
                errors.documento = { hasError: true, hintText: "" }
            }
        }

        if (!cliente?.nome || cliente?.nome === "") {
            const msg = `O campo ` + (tipoCliente !== "juridica" ? `Nome completo do Cliente` : `Razão Social`) + ` é obrigatório.`
            errorMessages.push(msg)
            errors.nome = { hasError: true, hintText: "" }
        }else if(cliente?.nome?.trim()?.split(" ")?.length < 2 && tipoCliente !== "juridica") {
             errorMessages.push(`O campo (${tipoCliente !== "juridica" ? "Nome completo do Cliente" : "Razão Social"}) deve conter pelo menos 2 nomes`)
             errors.nome = { hasError: true, hintText: "" }
        }

        if (tipoCliente === "juridica") {
            if (!cliente?.fantasia || cliente?.fantasia === "") {
                errorMessages.push(`O campo "Nome Fantasia" é obrigatório.`)
                errors.nome_fantasia = { hasError: true, hintText: "" }
            }

            if ((!cliente?.inscricao_estadual || cliente?.inscricao_estadual === "") && cliente?.tipo_contribuinte === "contribuinte") {
                errorMessages.push(`O campo "Inscrição Estadual" é obrigatório.`)
                errors.inscricao_estadual = { hasError: true, hintText: "" }
            }

            if (!cliente?.tipo_contribuinte) {
                errorMessages.push(`O campo "Tipo Contribuinte" é obrigatório.`)
                errors.tipo_contribuinte = { hasError: true, hintText: "" }
            }
        }

        if (!cliente?.telefone || cliente?.telefone === "") {
            errorMessages.push(`O campo "Telefone" é obrigatório.`)
            errors.telefone = { hasError: true, hintText: "" }
        }else if(!ValidateUtil.isValidPhone(cliente?.telefone)){
            errorMessages.push(`Telefone informado não é válido.`)
            errors.telefone = { hasError: true, hintText: "" }
        }

        if (!cliente?.email || cliente?.email === "") {
            errorMessages.push(`O campo "Email" é obrigatório.`)
            errors.email = { hasError: true, hintText: "" }
        }else if(!isValidEmail(cliente?.email)){
            errorMessages.push(`E-mail informado não é válido.`)
            errors.email = { hasError: true, hintText: "" }
        }
        if (errorMessages.length > 0) {
            setErrorState({ ...errors })
            notifierStore.setNotifier({
                title: "Aviso",
                content: errorMessages,
                timeOut: 3500,
                onClose: () => {
                    notifierStore.setOpen(false)
                }
            })
            notifierStore.setOpen(true)

            return false
        }

        return true;
    }

    const prosseguir = async () => {
        const messages = [];

        if (!validateCliente()) {
            return
        }

        const userInfo = LocalStorage.get("solar.userInfo", true);

        let usuarioWhatsapp = "";

        const pedido = PedidoStore.getPedido();
        if (!pedido?.codigo_venda) {
            messages.push("Pedido não encontrado!");
        }

        let responseClientes = null;

        const _cliente: Clientes = CollectionUtil.merge({}, cliente)

        if (isWhatsApp && (_cliente?.contato_whatsapp === "" || _cliente?.contato_whatsapp === null)) {
            notifierStore.setNotifier({
                title: "Aviso",
                content: "Numero de WhatsApp não digitado!",
                timeOut: 3500,
                onClose: () => {
                    notifierStore.setOpen(false);
                }
            })
            notifierStore.setOpen(true);
            return;
        }

        if (_cliente?.contato_whatsapp) {
            const contato = _cliente.contato_whatsapp.replace(/\D/g, "");

            const enderecoResult: EnderecosClientes = enderecos?.find((e: EnderecosClientes) => e.selecionado_pagamento === true);

            const response: IDataResponse = await clientesProvider.postClienteWhatsapp(contato, enderecoResult.pais_id ? enderecoResult.pais_id : 1048);
            if (response.statusCode === STATUS_CODE.OK) {
                if (!response.data.usuario) {
                    messages.push("Contato para whatsapp não é valido!");
                } else {
                    usuarioWhatsapp = response.data.usuario
                    
                    const clienteInput = {
                        ..._cliente,
                        usuario_id: userInfo.userId,
                        tipo_pessoa: tipoCliente,
                        usuario_whatsapp: usuarioWhatsapp,
                        enderecos: enderecos?.map((e: any) => {
                            return { ...e, nao_valida_pedido: true }
                        }),
                    }

                    responseClientes = await onSaveCliente(clienteInput);
                }
            } else {
                if (response.statusCode === STATUS_CODE.UNAUTHORIZED)
                    messages.push("Acesso expirado, token revogado. Por favor refazer o login");
                    messages.push("O Número de Whatsapp informado não foi localizado, por gentileza verificar!");
            }
        } else {
            const clienteInput = {
                ...cliente,
                usuario_id: userInfo.userId,
                tipo_pessoa: tipoCliente,
                enderecos: enderecos?.map((e: any) => {
                    return { ...e, nao_valida_pedido: true }
                }),
            }

            responseClientes = await onSaveCliente(clienteInput);
        }

        if (!responseClientes?.data || !responseClientes?.data.length) {
            notifierStore.setNotifier({
                title: "Aviso",
                content: responseClientes?.message || messages || "Ocorreu um erro ao realizar o cadastro do cliente",
                timeOut: 3500,
                onClose: () => {
                    notifierStore.setOpen(false)
                }
            })
            notifierStore.setOpen(true);
            return
        }

        if (!validaClienteTemEnderecos()) {
            messages.push("Endereço de entrega ainda não foi adicionado!");
        }

        const enderecoId: EnderecosClientes = responseClientes.data[0].enderecos?.find((e: EnderecosClientes) => e.selecionado_pagamento === true);

        if (!enderecoId?.id) {
            messages.push("Endereço ainda não foi selecionado!");
        }

        messages.push(...validarEndereco(enderecoId));

        if (messages.length > 0) {
            notifierStore.setNotifier({
                title: "Aviso",
                content: messages,
                timeOut: 3500,
                onClose: () => {
                    notifierStore.setOpen(false)
                }
            })
            notifierStore.setOpen(true);
            return
        }

        const clienteId: number = responseClientes.data[0]?.id;

        if (enderecos && clienteId) {

            const response = await pagamentosProvider.savePagamentosClienteEnderecos(pedido?.codigo_venda ? pedido.codigo_venda : "", clienteId, enderecoId?.id || 0);
            if (response.statusCode === STATUS_CODE.OK) {
                if (pedido?.codigo_venda) {

                    const enderecoEntrega = enderecos.find((_endereco: any) => _endereco.selecionado_pagamento)
                    if (enderecoEntrega) {
                        pedido.endereco_entrega = {
                            bairro: enderecoEntrega.bairro,
                            cep: enderecoEntrega.cep,
                            cidade: enderecoEntrega.cidade.nome,
                            logradouro: enderecoEntrega.logradouro,
                            complemento: enderecoEntrega.complemento,
                            estado: enderecoEntrega.cidade.estado_id,
                            numero: enderecoEntrega.numero,
                            pedido_id: pedido.id,
                        }
                    }

                    PedidoStore.setPedido(pedido);
                    history.push('/etapa/pagamento')
                }
            }
        }

    }

    const retornarTipoPessoa = () => {
        if (tipoCliente === "fisica")
            return "FÍSICA"

        return "JURÍDICA"
    }

    // validação para dados de endereço selecionado
    // adicionado somente a validação para o numero para correção de bug, tem que adicionar os demais campos
    const validarEndereco = (endereco: EnderecosClientes): string[] =>{
        const message = [];

        if (!endereco?.numero || endereco?.numero === "") {
            message.push(`O campo "Numero" do endereço é obrigatório.`)
        }

        return message;
    }
    useEffect(()=>{
        if(triangular){
            setDisabledList(DISABLED_TIPOS_CONTRIBUINTE);
            setTipoCliente("juridica")
        }
    },[triangular])

    const renderBotaoAdicionarNovoEndereco = useCallback(({ disabled = false }: { disabled?: boolean })=>{
        return (
            <div style={{ width: "auto"}}>
                <FullWidthButton
                    disabled={!!disabled}
                    disableElevation={true}
                    text={"Adicionar Novo Endereço"}
                    color={"primary"}
                    variant={"contained"}
                    onClick={async () => {
                        const pedido = PedidoStore.getPedido();
                        if (pedido?.codigo_venda) {
                            const substituicaoResult = await pedidosProvider.verificarSubstituicao(pedido.codigo_venda);
                            if (substituicaoResult.statusCode !== STATUS_CODE.OK) return;
                        }

                        if (!validaClienteExiste() && !validaClienteTemEnderecos())
                            return

                        if (cliente?.tipo_pessoa === "juridica" && cliente.tipo_contribuinte === "contribuinte") {
                            notifierStore.setNotifier({
                                title: "Aviso",
                                content: "Para contribuintes de ICMS o endereço de entrega será o mesmo de faturamento!",
                                timeOut: 3500,
                                onClose: () => {
                                    notifierStore.setOpen(false)
                                }
                            })
                            notifierStore.setOpen(true)

                            return
                        }

                        setPaisState(paisesListState?.find((pais: Paises) => pais.nome === 'BRASIL'))
                        handleOpenModal();
                        setIndexEdicaoCliente(-1);
                    }}
                />
            </div>
        )
    },[cliente?.tipo_contribuinte, cliente?.tipo_pessoa, paisesListState, validaClienteExiste, validaClienteTemEnderecos])

    return <>
        <div className="ClienteForm">
            <div className="row">
                <div className="seletorCliente">
                    {!triangular && (<FlatButton
                        text={"Cliente Pessoa Física"}
                        disabled={validaClienteExisteDocumento()}

                        onClick={() => {
                            limparClienteState("");
                            setCliente(limparClienteState(""));
                            setTipoCliente("fisica");
                            setLimparEndereco(!limparEndereco);
                        }}
                    />)}
                    <FlatButton
                        text={"Cliente Pessoa Jurídica"}
                        disabled={validaClienteExisteDocumento()}
                        onClick={() => {
                            limparClienteState("");
                            setCliente(limparClienteState(""));
                            setTipoCliente("juridica");
                            setLimparEndereco(!limparEndereco);
                        }}
                    />
                </div>
            </div>

            {tipoCliente === "juridica" ? <>
                <div className="row">
                    <div className="X12">
                        <Alert severity="warning" className="texto-alerta">
                            A emissão da NF e a entrega da mercadoria será obrigatoriamente no endereço cadastrado na Receita Federal.
                        </Alert>
                    </div>
                </div>
            </> : null}

            <div className="row">
                <div className="X12">
                    <Alert severity="info" className="texto-alerta">
                        Lembre-se que a autenticidade das informações é necessária para a sequência do fluxo de pagamento. Portanto, é de suma importância que campos de contato como e-mail e telefones sejam autênticos.
                    </Alert>
                </div>
            </div>

            <div className="row">
                <div className="X12" style={{ textAlign: "left", paddingTop: "10px", paddingLeft: "10px" }}>
                    <strong style={{ color: theme.palette.grey[500] }}>Dados pessoais ( {retornarTipoPessoa()} )</strong>
                    <Divider />
                </div>
            </div>
            <div className="row">

                <div className="X12 M6">
                    <InputText
                        label={`${tipoCliente !== "juridica" ? "CPF" : "CNPJ"} *`}
                        fullWidth
                        disabled={validaClienteExisteDocumento()}
                        error={errorState.documento.hasError}
                        mask={tipoCliente !== "juridica" ? "cpf" : "cnpj"}
                        value={cliente?.documento}
                        onChange={(e: any) => {
                            const value = e.target.value;
                            const state: Clientes = CollectionUtil.merge({}, cliente);

                            state.documento = value;
                            setCliente(state);
                        }}
                        onFocus={() => {
                            const _error: ErrorState = CollectionUtil.merge({}, errorState)
                            _error.documento.hasError = false;
                            setErrorState(_error);
                        }}
                        onBlur={async (event: any) => {
                            const value = event.target.value;
                            const state: Clientes = CollectionUtil.merge({}, cliente);
                            state.documento = value;
                            const _c = limparClienteState(value)
                            setCliente(_c)
                            let isValid = false;
                            const tipoDocumento = StringUtil.validaTipoDocumento(String(state?.documento));

                            if (tipoDocumento === "CPF") {
                                isValid = ValidateUtil.isValidCPF(String(state.documento))
                            }

                            if (tipoDocumento === "CNPJ") {
                                isValid = ValidateUtil.isValidCNPJ(String(state.documento))
                            }

                            if (!isValid) {
                                const _error: ErrorState = CollectionUtil.merge({}, errorState);
                                _error.documento.hasError = true;
                                _error.documento.hintText = `${tipoDocumento} inválido`;
                                setErrorState(_error)
                                return;
                            }

                            const pedido = PedidoStore.getPedido();
                            if (pedido?.codigo_venda) {
                                const pedidosProvider = new PedidosProvider();
                                const responsePedido: IDataResponse<PedidoType[]> = await pedidosProvider.getPedidos(pedido.codigo_venda);
                                if (responsePedido.statusCode !== STATUS_CODE.OK) return;
                            }

                            await consultaClienteCRM(value)
                        }}
                    />
                </div>

                {tipoCliente !== "juridica" ? (
                    renderPessoaFisica()
                ) : (
                    renderPessoaJuridica()
                )}

                <div className="X12 M6">
                    <InputText label="E-mail *" fullWidth
                        value={cliente?.email}
                        disabled={searchClient || !!cliente?.cliente_sales_force}
                        error={errorState.email.hasError}
                        onChange={(e: any) => {
                            const state = CollectionUtil.merge({}, cliente)
                            state.email = e.target.value;
                            setCliente(state);
                        }}
                    />
                </div>

                <div className="X12 M6">
                    <InputText
                        label="Telefone *"
                        mask="phone"
                        fullWidth
                        value={cliente?.telefone}
                        disabled={searchClient || !!cliente?.cliente_sales_force}
                        error={errorState.telefone.hasError}
                        onChange={(e: any) => {
                            const state = CollectionUtil.merge({}, cliente)
                            const _value = e.target.value;
                            state.telefone = _value;
                            setCliente(state);
                        }}
                    />
                </div>
            </div>
            <div className="row">
                <FormControlLabel
                    label="Desejo receber atualizações sobre o pedido por WhatsApp"
                    control={
                        <Checkbox
                            value={isWhatsApp}
                            checked={isWhatsApp}
                            disabled={searchClient}
                            onChange={(e: any) => {
                                setIsWhatsApp(e.target.checked);
                                const state = CollectionUtil.merge({}, cliente)

                                state.usa_whatsapp = e.target.checked;

                                if (e.target.checked) {

                                    if (!state.contato_whatsapp && state.telefone) {
                                        const _telefone = state.telefone.replace(/\D/g, "");

                                        if (_telefone) {
                                            const digitoVerificador = Number(_telefone.charAt(4));
                                            if (digitoVerificador) {
                                                if (digitoVerificador >= 6 && digitoVerificador <= 9) {
                                                    state.contato_whatsapp = state.telefone;
                                                }
                                            }
                                        } else {
                                            state.contato_whatsapp = "";
                                        }
                                    }
                                } else {
                                    state.contato_whatsapp = "";
                                }

                                setCliente(state);
                            }}
                        />
                    }
                />
            </div>
            {cliente?.usa_whatsapp ? (
                <div className="row">
                    <div className="X12 M6">
                        <InputText
                            mask="phone"
                            label="Contato WhatsApp*"
                            disabled={searchClient}
                            fullWidth
                            value={cliente?.contato_whatsapp}
                            onChange={(e: any) => {
                                const state = CollectionUtil.merge({}, cliente)
                                const _value = e.target.value;
                                state.contato_whatsapp = _value;
                                setCliente(state);
                            }}
                        />
                    </div>
                </div>
            ) : ""}
            <div className="row div-center" style={{ alignItems: "center" }}>
                <strong style={{ color: theme.palette.grey[500], display: "block", width: "max-content", marginRight: "10px" }}>Endereço de entrega do produto</strong>
                {validaClienteTemEnderecos() ? (tipoCliente === "juridica" ?
                    (
                        <Tooltip title="Inserção de endereço bloqueada para clientes CNPJ">
                            <span>
                                {renderBotaoAdicionarNovoEndereco({ disabled: true })}
                            </span>
                        </Tooltip>
                    ) :
                    (
                        renderBotaoAdicionarNovoEndereco({ disabled: false })
                    )
            ) : ""}
            </div>
            <div className="row">
                <div className="X12" style={{ paddingTop: "10px", paddingLeft: "10px" }}>
                    <Divider />
                </div>
            </div>
            <div className="row">
                {validaClienteTemEnderecos() ? enderecos?.map((row, index) => (
                    <div className="X12 M3" style={{ paddingTop: "10px", paddingLeft: "10px" }} key={`cliente-form-card-endereco-${index}`}>
                        <Card>
                            <CardContent>
                                <div className="card-endereco">

                                    <div className="header">
                                        <div className="title">
                                            {row.descricao}
                                        </div>
                                        <div className="action">
                                            <Checkbox
                                                checked={row.selecionado_pagamento}
                                                onChange={(event: any) => {

                                                    const state = enderecos.map((e: any) => {
                                                        return { ...e, selecionado_pagamento: false }
                                                    })

                                                    state[index].selecionado_pagamento = event.target.checked;
                                                    setEnderecos(state);
                                                }} />
                                        </div>
                                    </div>
                                    <div className="card-info">{row?.logradouro}</div>
                                    <div className="card-info">{row?.numero}</div>
                                    <div className="card-info">{row?.bairro} - {row?.cidade?.nome} - {row?.cidade?.estado_id}</div>
                                    <div className="card-info">{cepParser(row.cep)}</div>
                                    <div className="card-info">{row?.pais.nome}</div>
                                    <div className="card-info">{row?.complemento ? row?.complemento : <br />}</div>
                                    <div className="card-info">{row?.nome ? row.nome : <br />}</div>
                                    <div className="card-info">{row?.telefone ? parsePhone(row.telefone) : <br />}</div>
                                </div>
                            </CardContent>
                            <CardActions >
                                <div className="row">
                                    <div className="X12 M6">
                                        <Button
                                            size="small"
                                            color="primary"
                                            disabled={row.origem_endereco === TTIPO_ORIGEM_ENDERECO.ENDERECO_CRM}
                                            onClick={() => {

                                                const value: EnderecosClientes = {
                                                    ...row
                                                }
                                                setPaisState(row.pais);
                                                setEnderecoEdit(value);
                                                handleOpenModalEdit();
                                                setIndexEdicaoCliente(index);
                                            }}>
                                            Editar
                                        </Button>
                                    </div>
                                </div>
                            </CardActions>
                        </Card>
                    </div>
                )) : renderEnderecoAdicionarClienteNovo()}
            </div>
            {renderEnderecoAdicionar()}
            {renderEnderecoEditar()}
        </div>

        <BottomBar>
            <FullWidthButton
                disableElevation={true}
                text={"Prosseguir"}
                color={"primary"}
                variant={"contained"}
                onClick={async () => {
                    const pedido = PedidoStore.getPedido();
                    if (pedido?.codigo_venda) {
                        const substituicaoResult = await pedidosProvider.verificarSubstituicao(pedido?.codigo_venda || "")
                        if (substituicaoResult.statusCode !== STATUS_CODE.OK) return;
                    }
                    prosseguir()
                }}
            />

        </BottomBar>
    </>
}

export { ClienteForm };
